var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenuItem',{attrs:{"icon":_vm.icon,"title":_vm.title}},[_c('input',{staticClass:"hidden-input-file",attrs:{"type":"file","multiple":"","title":""},on:{"change":function($event){return _vm.$emit('change', $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }